import Rollbar from 'rollbar';
import { env } from './env';

let rollbar: Rollbar | null = null;

export const initRollbar = () => {
  const accessToken = env.ROLLBAR_ACCESS_TOKEN;
  const environment = env.ROLLBAR_ENVIRONMENT;

  if (!accessToken) {
    // Silently skip Rollbar initialization if no access token is provided
    return null;
  }

  if (rollbar) {
    return rollbar;
  }

  try {
    rollbar = new Rollbar({
      accessToken,
      environment: environment || 'development',
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        client: {
          javascript: {
            code_version: env.APP_GIT_COMMIT_SHA || 'unknown',
            source_map_enabled: true,
          },
        },
        environment: environment || 'development',
      },
    });

    return rollbar;
  } catch (error) {
    // Silently fail if Rollbar fails to initialize
    console.error('Failed to initialize Rollbar:', error);
    return null;
  }
};

// Log error to Rollbar
export const logError = (error: Error, additionalData?: Record<string, unknown>) => {
  if (!rollbar) {
    // Silently skip if Rollbar is not initialized
    return;
  }

  rollbar.error(error, additionalData);
};
